<!-- SPDX-FileCopyrightText: © 2025 Schneider Electric SPDX-License-Identifier: Apache-2.0 -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m4.77 13.97-.62-.78 6.62-5.23-6.62-5.11.61-.79 7.63 5.89z"/></svg>